module.exports = __webpack_public_path__ + "img/ntt_form_ogp.81a2c917.png";